/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
import { colord } from "colord";

// below here for testing imports
import { RangeControl } from '@wordpress/components';

const { assign, merge } = lodash;
const { __ } = wp.i18n;
const { PanelBody } = wp.components;



const PullPanel = (myprops) => {

// Need to understand what I am passing here
	const props = myprops.props
	const {attributes,setAttributes} = props;
	const {aplomargintop,aplomarginleft,aplomarginright,aplomarginbottom,haspullstyles} = props.attributes;

	function rangeControlPull(att, currentvalue, min, max, position) {

		function updateValue(newvalue) {
			if (newvalue !== 0) {
				setAttributes({[att]:newvalue})
			} else {
				setAttributes({[att]:undefined})
			}
			if (currentvalue === undefined && newvalue !== 0) {
				setAttributes({haspullstyles:haspullstyles + 1});
			} else if (currentvalue !== undefined && (newvalue === undefined  || newvalue === 0)) {
				setAttributes({haspullstyles:haspullstyles - 1 });
			}

		}


		return(
			<RangeControl
				value={ currentvalue }
				onChange={ updateValue }
				min={ min }
				max={ max}
				step={1}
				allowReset={true}
				initialPosition={position}
			/>
		);
	
	}

	
	

	return (

		<PanelBody title={__('Aplo Pull Styles', 'aploblocks')} initialOpen={false} className="">

					<p>{__('Add negative margins to blocks','aploblocks')}</p>
					
					<h2>Pull up</h2>					
					{rangeControlPull("aplomargintop",aplomargintop,-500,0,0)}
					<h2>Pull down</h2>					
					{rangeControlPull("aplomarginbottom",aplomarginbottom,-500,0,0)}
					<h2>Pull left</h2>					
					{rangeControlPull("aplomarginleft",aplomarginleft,-500,0,0)}
					<h2>Pull right</h2>					
					{rangeControlPull("aplomarginright",aplomarginright,-500,0,0)}

				</PanelBody>


	)




}



export default PullPanel